import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Auth from "./components/Auth";
import "./components/Auth.css";
import Layout from "./components/Layout";
import Notification from "./components/Notification";
import { uiActions } from "./store/UI-Slice";
import { fetchData, sendCartData } from "./store/cart-actions";

let isFirstRender = true;

function App() {
  const dispatch = useDispatch();
  const notification = useSelector((state) => state.ui.notification);

  const cart = useSelector((state) => state.cart);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  useEffect(()=> {
    dispatch(fetchData())

  },[dispatch])

  useEffect(() => {
    if (isFirstRender) {
      isFirstRender = false;
      return;
    }

    if(cart.changed){
      dispatch(sendCartData(cart));
    }
    dispatch(sendCartData(cart));
  }, [cart, dispatch]);

  return (
    <div className="App">
      {notification && (
        <Notification type={notification.type} message={notification.message} />
      )}
      {!isLoggedIn && <Auth />}
      {isLoggedIn && <Layout />}
    </div>
  );
}

export default App;